module.exports = __webpack_public_path__ + "static/media/sedematLogo.9e632844.png";